import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cloudlabs-rank',
  templateUrl: './rank.component.html',
  styleUrls: ['./rank.component.scss']
})
export class RankComponent {

  @Input() rank: number;
  @Input() isButton: boolean;
  @Input() userVoucher: any;
  @Input() uniqueName: any;
  @Input() level: any;
  @Output() whenClick = new EventEmitter<any>();

  btnClick(){
    this.whenClick.emit();
  }
}
